import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createCookie } from  '../shared/cookie.js';

import { closeModal, openLoginModal } from '../modules/active_modal';
import { captureLead } from '../modules/customer';


class PopupEnrollEmailCapture extends Component {

  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      email    : ''
    };
    this.handleChange     = this.handleChange.bind(this);
  }

  captureLead( evt ) {
    evt.preventDefault();
    let oLead        = {};
    oLead.firstName  = this.state.firstName;
    oLead.email      = this.state.email;
    this.props.dispatch( captureLead( oLead ) );
  }

  handleChange( sType, event ) {
    let oUpdate = {};
    oUpdate[ sType ] = event.target.value;
    this.setState( oUpdate );
  }

  componentWillReceiveProps(){
    createCookie('seenEnrollModal', true, 1440 );
  }

  render() {
    let {dispatch}      = this.props;
    return (
      <div className="modal-window email-capture-wrapper">

        <div className="enroll-header">
          <div className="fs-medalion">
            <img src={"/images/" + this.props.tla.toLowerCase() + "/fs-medallion.svg"} />
          </div>
          <div className="offer">
            <h2>Join {this.props.name}<sup>&reg;</sup> today &</h2>
            <h1>Get your first book for <span className="no-wrap">only $11.99</span></h1>
          </div>
        </div>
        <div className="email-capture">
          <section>
            <h4>Enter your name and email to get started</h4>
            <form name="emailModal" onSubmit={this.captureLead.bind( this )}>
              <input
                type        = "text"
                onChange    = {this.handleChange.bind( this, 'firstName' )}
                placeholder = "First Name"
                value       = {this.state.firstName}
                name        = 'firstName'
                required
              />
              <input
                type        = "email"
                onChange    = {this.handleChange.bind( this, 'email' )}
                placeholder = "Email"
                value       = {this.state.email}
                name        = 'email'
                required
              />
              <button className="btn-primary fat">Get your first book for $11.99</button>
              <br />
              <span className="help-link" onClick={() => dispatch( closeModal() )}>No thanks, just browsing.</span>
            </form>
          </section>
          <section>
            <h4>Already a Member? </h4>
            <button className="btn-secondary fat" onClick={() => dispatch( openLoginModal() )}>
              Log In
            </button>
          </section>
        </div>
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'tla': state.store.tla,
      'name': state.store.name
    };
}

export default connect(mapStateToProps)(PopupEnrollEmailCapture);


// WEBPACK FOOTER //
// ./src/components/PopupEnrollEmailCapture.jsx